"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _oneWeir = require("@weirgroup/one-weir");
var _weirDls = require("@weirgroup/weir-dls");
var _addteammemberModule = _interopRequireDefault(require("./addteammember.module.css"));
var _languageMsg = _interopRequireDefault(require("./languageMsg"));
var _addteammember = _interopRequireDefault(require("./addteammember.constant"));
var _manageYourTeam = require("../manageYourTeam.action");
var _common = require("../../../utilities/common");
class AddTeamMember extends _react.default.Component {
  static formatDropDownValues(data, property) {
    const emailList = [];
    if (data !== undefined) {
      data.map(obj => {
        Object.keys(obj).forEach(prop => {
          if (prop === property && obj[prop]) {
            emailList.push({
              value: obj[prop],
              label: obj[prop]
            });
          }
        });
      });
    }
    return emailList;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.usersList) {
      this.setState({
        usersList: AddTeamMember.formatDropDownValues(nextProps.assignableUserList, _addteammember.default.USEREMAIL)
      });
    }
  }
  constructor(props) {
    super(props);
    this.onClickNextButton = () => {
      this.props.handleNextButtonClick(this.state.assignedUsersList);
    };
    this.state = {
      trimEmail: false,
      usersList: AddTeamMember.formatDropDownValues(this.props.assignableUserList, _addteammember.default.USEREMAIL),
      assignedUsersList: []
    };
    this.handleChangeAppRole = this.handleChangeAppRole.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.onClickNextButton = this.onClickNextButton.bind(this);
  }
  componentDidMount() {
    this.props.getUsersForSelectedRole(this.props.appId);
    this.setState({
      assignedUsersList: this.props.selectedUsersList
    });
  }
  handleChangeAppRole(selectedAppRole) {
    var _this$props$roles;
    const roleObj = (_this$props$roles = this.props.roles) === null || _this$props$roles === void 0 ? void 0 : _this$props$roles.find(obj => obj.value === selectedAppRole);
    this.props.handleChangeAppRole(roleObj ? roleObj : '');
    this.props.getUsersForSelectedRole(this.props.appId);
  }
  removeUser(user) {
    const index = this.state.assignedUsersList.indexOf(user);
    const usersListAssigned = this.state.assignedUsersList;
    if (index > -1) {
      usersListAssigned.splice(index, 1);
    }
    this.setState({
      assignedUsersList: usersListAssigned
    });
  }
  onClickEmailAdd(value) {
    const emailsList = Object.assign([], this.state.assignedUsersList);
    if (!this.state.assignedUsersList.includes(value.value)) {
      emailsList.push(value.value);
    }
    this.setState({
      assignedUsersList: emailsList
    }, () => {
      this.onChangeMultiEmail({
        emailList: this.state.assignedUsersList,
        emailSearch: ''
      });
      this.setState({
        trimEmail: true
      });
    });
  }
  onChangeMultiEmail(e) {
    const list = [...e.emailList];
    this.setState({
      trimEmail: false
    });
    if (typeof e.emailSearch === 'undefined') {
      this.setState({
        assignedUsersList: list,
        usersList: AddTeamMember.formatDropDownValues(this.props.assignableUserList, _addteammember.default.USEREMAIL)
      });
    } else {
      // filter data
      const queryText = e.emailSearch;
      let queryResult = [];
      this.props.assignableUserList.forEach(userList => {
        if (userList.email) {
          if (queryText && userList.email.toLowerCase().includes(queryText.toLowerCase())) {
            queryResult.push(userList);
          }
        }
      });
      if (!queryText) {
        queryResult = this.props.assignableUserList;
      }

      // filter data
      this.setState({
        usersList: AddTeamMember.formatDropDownValues(queryResult, _addteammember.default.USEREMAIL)
      });
      if (!(0, _common.arrayEquals)(Object.assign([], this.state.assignedUsersList), e.emailList)) {
        this.setState({
          assignedUsersList: e.emailList
        });
      }
    }
  }
  render() {
    var _this$props$selectedA, _this$state$assignedU;
    const {
      roles
    } = this.props;
    const {
      usersList
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: _addteammemberModule.default.dropdownMarginBottom,
      "data-testid": "addTeamRole"
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Dropdown, {
      name: "addTeamRole",
      value: (_this$props$selectedA = this.props.selectedAppRole) === null || _this$props$selectedA === void 0 ? void 0 : _this$props$selectedA.value,
      setValue: this.handleChangeAppRole,
      label: _addteammember.default.SELECT_APP_ROLE_TITLE,
      required: true,
      selectData: roles,
      requiredText: _addteammember.default.REQUIRED,
      placeholderText: _addteammember.default.SELECT_APP_ROLE_PLACEHOLDER
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _addteammemberModule.default.mineSitesPanel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _addteammemberModule.default.emailPanel
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "multiEmail"
    }, /*#__PURE__*/_react.default.createElement(_weirDls.MultiEmailField, {
      label: _addteammember.default.ADD_TEAM_MEMBERS_TO_MINE_SITE_AND_ROLE.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular.toUpperCase()),
      onChange: e => {
        this.onChangeMultiEmail(e);
      },
      placeholder: _addteammember.default.SELECT_MINE_SITES_PLACEHOLDER.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular),
      validationState: "",
      emails: this.state.assignedUsersList,
      isEmailValidationRequired: true,
      requiredLabel: _addteammember.default.REQUIRED,
      readonly: false
    })), /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "nextBtn",
      className: _addteammemberModule.default.nextBtn + ' ' + _addteammemberModule.default.margin25
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      onClick: this.onClickNextButton,
      label: _languageMsg.default.NEXT_LABEL,
      variant: "primary",
      disabled: !(this.state.assignedUsersList !== undefined && ((_this$state$assignedU = this.state.assignedUsersList) === null || _this$state$assignedU === void 0 ? void 0 : _this$state$assignedU.length) > 0 && this.props.selectedAppRole)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: _addteammemberModule.default.usersList
    }, usersList && usersList !== null && usersList !== void 0 && usersList.length ? /*#__PURE__*/_react.default.createElement(_oneWeir.DropdownOptionsList, {
      "data-testid": "emaiList",
      buttonSize: _addteammember.default.MEDIUM,
      height: "440px",
      width: "590px",
      itemList: usersList,
      onClick: e => {
        this.onClickEmailAdd(e);
      }
    }) : /*#__PURE__*/_react.default.createElement(_oneWeir.DropdownOptionsList, {
      buttonSize: _addteammember.default.MEDIUM,
      height: "440px",
      width: "590px",
      itemList: [],
      noOptionFoundLabel: _addteammember.default.NOT_FOUND,
      onClick: () => {}
    }))));
  }
}
const mapStateToProps = state => ({
  roles: state.manageYourTeam.roles,
  appinfo: state.manageYourTeam.appinfo,
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
function mapDispatchToProps(dispatch) {
  return {
    getRolesForSelectedApp: () => {
      dispatch((0, _manageYourTeam.getRolesForSelectedApp)());
    },
    getUsersForSelectedRole: appId => {
      dispatch((0, _manageYourTeam.getUsersForSelectedRole)(appId));
    }
  };
}
;
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddTeamMember);